export const routerEmpleo = [
  {
    path: '/empleo/:id',
    name: 'empleo-detalle',
    component: () => import(/* webpackChunkName: "mis-postulaciones" */ '../Detalle.vue'),
  },
]